import { useRoute } from 'vue-router'
import { useServiceTemplatesStore } from '@/stores/serviceTemplates'
import { useGeolocationStore } from '@/stores/geolocation'
import { isTrueString } from '@/utils'
import { computed } from 'vue'

let _isFirstEntry = null

export const useCustomRouter = () => {
  function inResultPage(route = null) {
    const name = (route ?? useRoute()).name
    const serviceStore = useServiceTemplatesStore()
    const geolocaliationStore = useGeolocationStore()

    return (
      serviceStore.currentServiceTemplate !== null &&
      geolocaliationStore.isGeolocationValid() &&
      name === 'home'
    )
  }

  function inHomePage(route = null) {
    const name = (route ?? useRoute()).name
    const serviceStore = useServiceTemplatesStore()
    const geolocaliationStore = useGeolocationStore()

    return (
      name === 'home' &&
      (serviceStore.currentServiceTemplate === null || !geolocaliationStore.isGeolocationValid())
    )
  }

  function setAlreadyEntered() {
    if (isFirstEntry.value) {
      sessionStorage.setItem('alreadyEntered', 'true')
    }
  }

  const isFirstEntry = computed(() => {
    if (_isFirstEntry !== null) {
      return _isFirstEntry
    }

    _isFirstEntry = !isTrueString(sessionStorage.getItem('alreadyEntered'))

    return _isFirstEntry
  })

  return {
    inResultPage,
    inHomePage,
    setAlreadyEntered,
    isFirstEntry
  }
}
